<template>
  <div class="myExplain">
    <div class="top" v-if="type!=='phone'">
      <van-icon size="22px" name="arrow-left" @click="back" />
      <span class="title">{{ $t('append_field.video_tutorial')}}</span>
    </div>
    <div class="video-content">
      <div class="scroll">
        <div class="downTitle">{{ 'packages' }} </div>
          <van-cell v-for="(item) in packages" :key="item.id" :icon="gotoAddress(item.hpIconAddress)" alt="">
            <template #title>
              <span v-if="language === 'zh'">{{ truncatedName(item.hpTitle) }}</span>
              <span v-else>{{ truncatedName(item.hpVersion) }}</span>
            </template>
            <template #right-icon>
              <van-button color="#006EFF" size="small" @click="goto(item.hpDownUrl)">{{ $t('append_field.download') }}</van-button>
            </template>
          </van-cell>

        <div class="downTitle">{{ $t('append_field.document') }} </div>
          <van-cell v-for="(item) in words" :key="item.id" :icon="gotoAddress(item.hpIconAddress)" alt="">
            <template #title>
              <span v-if="language === 'zh'">{{ truncatedName(item.hpTitle) }}</span>
              <span v-else>{{ truncatedName(item.hpVersion) }}</span>
            </template>
            <template #right-icon>
              <van-button color="#006EFF" size="small" @click="goto(item.hpDownUrl)">{{ $t('append_field.download') }}</van-button>
            </template>
          </van-cell>

        <div class="downTitle">{{ $t('append_field.control_video') }} </div>
          <van-cell v-for="(item) in videos" :key="item.id" :icon="gotoAddress(item.hpIconAddress)" alt="">
            <template #title>
              <span v-if="language === 'zh'">{{ truncatedName(item.hpTitle) }}</span>
              <span v-else>{{ truncatedName(item.hpVersion) }}</span>
            </template>
            <template #right-icon>
              <van-button color="#006EFF" size="small" @click="goto(item.hpDownUrl)">{{ $t('append_field.view') }}</van-button>
            </template>
          </van-cell>


      </div>
      <van-empty
          v-if="videos.length===0 && packages.length===0 && words.length===0"
          class="custom-image"
          image="/static/images/terminal/empty-img.png"
          :description="$t('append_field.data_empty')"
      />
    </div>
    <van-overlay :show="loading_show" @click="loading_show = false">
      <div class="wrapper" @click.stop>
        <van-loading  size="40px" vertical >{{$t('append_field.loadinga')}}</van-loading>
      </div>
    </van-overlay>
  </div>
</template>
<script>
  import Cookies from "js-cookie";
  import {getLanguage} from "@/lang";

  export default {
    data() {
      return {
        words: [],
        videos: [],
        packages: [],
        language:Cookies.get('language') || getLanguage(),
        loading_show:false,
        type:this.$route.query.type
      }
    },
    mounted() {
      this.loading_show=true
      this.$ajax.post("/etv/selectHelpInfo.json").then(res => {
        if (res.data.code === 0) {
          this.loading_show=false
          this.words = res.data.data.word
          this.videos = res.data.data.video
          this.packages = res.data.data.package
        }
      })

    },
    methods: {
      handleResize() {
        // 获取底部导航栏元素
        const tabbar = document.querySelector('.van-tabbar')
        tabbar.style.display = 'none'
      },
      back() {
        this.$router.push('/my')
      },
      goto(url) {
        window.open(url, '_blank')
      },
      gotoAddress(url){
        return url.replace('/web', '')
      },
      truncatedName(fullName) {
          // 截断名称并确保括号内容完整显示
          const namePart = fullName.split(' (')[0];
          const infoPart = fullName.includes('(') ? `${fullName.slice(fullName.indexOf('('))}` : '';

          // 判断是否为英文名（假设英文名不包含中文字符）
          const isEnglish = /^[A-Za-z\s]+$/.test(namePart);

          // 根据是否为英文名选择不同的截断长度
          const maxLength = isEnglish ? 24 : 14;

          if (namePart.length <= maxLength) {
            return fullName;
          } else {
            return `${namePart.substring(0, maxLength)}...${infoPart}`;
          }
      },
    }
  }
</script>

<style scoped lang="scss">
.myExplain {
  height: 100% !important;
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 55;
  background: #ffffff;
  display: flex;
  flex-direction: column;

  .top{
    padding:18px 10px;
    display: flex;
    align-items: center; /* 垂直居中对齐 */
    justify-content: center; /* 水平居中对齐 */
    position: relative; /* 使子元素可以相对于父元素定位 */
    border-bottom: #8c8c8c 1px solid;

    .van-icon {
      position: absolute; /* 绝对定位 */
      left: 10px; /* 根据需要调整左边距 */
    }
    .title{
      font-size: 18px;
      font-size: 18px;
      float: none; /* 确保不使用浮动 */
      display: inline-block; /* 使元素成为行内块级元素 */
    }
  }
  .video-content{
    height: 100%;
    background: #ffffff;
    overflow: auto;
    .van-cell{
      padding: 20px 16px;
    }
    .van-cell,.van-cell__left-icon,{
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .van-icon__image{
      height: 40px;
      width:40px;
    }
    .ellipsis{
      text-align: center;
    }
    .downTitle{
      background-color: #f2f2f2;
      padding: 10px;
      font-weight: bolder;
    }
  }
  .wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
  }
}
</style>